import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'message_values'

export default function MessageValuesPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: "What do you value most in someone's messages?",
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.messageValues.heading')}
      buttons={[
        {
          text: t('pages.onboarding.messageValues.options.thoughtfulness'),
          value: 'thoughtfulness',
        },
        {
          text: t('pages.onboarding.messageValues.options.humor'),
          value: 'humor',
        },
        {
          text: t('pages.onboarding.messageValues.options.honesty'),
          value: 'honesty',
        },
        {
          text: t('pages.onboarding.messageValues.options.curiosity'),
          value: 'curiosity',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
